import { AppStorage } from './appStorage';

export default new AppStorage('runnermaps');
